

































































































import { Component, Vue, Prop } from "vue-property-decorator";
import { MESSAGE } from "@/model/Message";
@Component
export default class JibaiseikiDialog extends Vue {
  @Prop() code: string;
  @Prop() value: number;
  @Prop({ default: false })
  appendToBody: string;
  showDialog: boolean = false;
  tableData: any = [];
  months: string[] = [];
  newTableData: any = [];
  newMonths: string[] = [];
  newFlg: boolean = false;
  newLabel: string = "";
  codeSelected: string = "";
  valueSelected: string = "";
  newCodeSelected: string = "";
  newValueSelected: string = "";
  hasData: boolean = false;
  hasNewData: boolean = false;
  loading: boolean = true;
  loadingText: string = MESSAGE.Loading;
  errorMessage: string = "";

  created() {
    this.codeSelected = this.code;
    if (this.value) {
      this.valueSelected = this.value.toString();
    }
  }

  selectJibaiseiki(code: string, value: string, month: string) {
    this.codeSelected = code;
    this.valueSelected = value;
    this.$emit("onJibaiseiki", {
      code,
      value: +value,
      month: month.replace("m", "")
    });
    this.onClose();//
  }

  selectNewJibaiseiki(code: string, value: string, month: string) {
    this.newCodeSelected = code;
    this.newValueSelected = value;
    this.$emit("onJibaiseiki", {
      code,
      value: +value,
      month: month.replace("m", "")
    });
    this.onClose();
  }

  cellClassName(code: string, cell: any) {
    if (cell.value == "0") {
      return "cell-disabled";
    }
    // if (code == this.codeSelected && cell.value == this.valueSelected) {
    //   return "selected";
    // }
    // 変更前・変更後のどちらを選択中の場合も、対応する変更前セルを選択状態にする。
    if (code == this.codeSelected &&
      (cell.value == this.valueSelected || cell.newValue == this.valueSelected)) {
      return "selected";
    }
    return "pointer";
  }

  newCellClassName(code: string, cell: any) {
    if (cell.newValue == null || String(cell.newValue).trim() === "" || Number(cell.newValue) === 0) {
      return "cell-disabled";
    }
    // 変更前・変更後のどちらを選択中の場合も、対応する変更後セルを選択状態にする。
    if (code == this.newCodeSelected &&
      (cell.value == this.newValueSelected || cell.newValue == this.newValueSelected)) {
      return "selected";
    }
    return "pointer";
  }

  setTableData(data: any) {
    if (data.length > 0) {
      this.$set(this, "hasData", true);
      this.$set(this, "tableData", data);
      let months = Object.keys(this.tableData[0]).slice(2, 8);
      this.$set(this, "months", months);
    }
  }

  setNewTableData(data: any, newFlg: number, displayLimit: string) {
    const date = (displayLimit || "").slice(0, 10).replace(/-/g, "/");
    this.newFlg = newFlg === 1 ? true : false ;
    this.newLabel = date ? `${date}以降` : "料金表";
    if (newFlg === 1 && data.length > 0) {
      this.$set(this, "hasNewData", true);
      this.$set(this, "newTableData", data);
      let months = Object.keys(this.newTableData[0]).slice(2, 8);
      this.$set(this, "newMonths", months);
    } else {
      this.$set(this, "hasNewData", false);
    }
  }

  onOpen() {
    this.showDialog = true;
    this.errorMessage = "";
    this.codeSelected = this.code;
  }

  onClose() {
    this.showDialog = false;
  }

  onDialog() {
    this.codeSelected = this.code;
    if (this.value) {
      this.valueSelected = this.value.toString();
    }
  }

  onDialogNew() {
    this.onDialog();
    this.newCodeSelected = this.code;
    if (this.value) {
      this.newValueSelected = this.value.toString();
    }
  }

  clearSelData() {
    this.codeSelected = "";
    this.valueSelected = "";
  }

  clearNewSelData() {
    this.clearSelData();
    this.newCodeSelected = "";
    this.newValueSelected = "";
  }

  getDataError(error: string) {
    this.loading = false;
    this.errorMessage = error;
  }
}
